// Ozera product-card "i" expand-in-place. Toggles a details panel reading Suited for / How to use /
// What it does straight from product metafields, with no navigation away from the page.
(function () {
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-oz-card-info-toggle]');
    if (!trigger) return;

    var card = trigger.closest('[data-oz-card]');
    if (!card) return;

    var panel = card.querySelector('[data-oz-card-info]');
    if (!panel) return;

    var expanded = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', String(!expanded));
    panel.hidden = expanded;
  });
})();
